<template>
  <div class="SendRequest">
    <v-card>
      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
          @submit.prevent="send"
          enctype="multipart/form-data"
        >
          <v-row>
            <v-col lg="1" md="3" sm="6">
              <v-text-field
                v-model="inn"
                name="inn"
                label="ИНН *"
                readonly
                class="innEditOff noHover"
                required
                :rules="rules.requred"
              />
            </v-col>
            <v-col lg="3" md="3" sm="6">
              <v-text-field
                v-model="orgName"
                name="orgName"
                label="Наименование организации *"
                readonly
                class="innEditOff noHover"
                required
                :rules="rules.requred"
              />
            </v-col>
            <v-col lg="2" md="3" sm="6">
              <v-select
                v-model="nologObl"
                :items="vidnologObl"
                label="Система налогообложения *"
                item-text="name"
                item-value="name"
                name="nologObl"
                required
                :error-messages="!nologObl ? '  ' : undefined"
              />
            </v-col>
            <v-col lg="2" md="3" sm="6">
              <v-text-field
                v-model="email"
                name="email"
                label="Email *"
                required
                :rules="rules.requred"
              />
            </v-col>
            <v-col lg="2" md="3" sm="6">
              <v-text-field
                v-model="name"
                name="name"
                label="Имя *"
                required
                :rules="rules.requred"
              />
            </v-col>
            <v-col lg="2" md="3" sm="6">
              <v-text-field
                v-model="phone"
                name="phone"
                label="Телефон *"
                placeholder="(xxx)xxx xx xx"
                prepend-icon="phone"
                v-mask="rules.phonemask"
                prefix="+7"
                required
                :rules="rules.requred"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col lg="2" md="3" sm="6">
              <v-text-field
                v-model="purchase_number"
                name="purchase_number"
                :label="`№ Закупки ${!no_purchase_number ? '*' : ''}`"
                :required="!no_purchase_number ? true : false"
                :error-messages="!purchase_number && !no_purchase_number ? '  ' : undefined"
              />
            </v-col>
            <v-col lg="2" md="3" sm="6">
              <v-checkbox v-model="no_purchase_number" label="Нет номера закупки" />
            </v-col>
            <v-col lg="2" md="3" sm="6">
              <v-text-field
                v-model="summ"
                name="summ"
                label="Сумма банковской гарантии *"
                readonly
                required
                :rules="rules.requred"
              />
            </v-col>
            <v-col lg="2" md="3" sm="6">
              <v-select
                v-model="calc.quaranteesVal"
                :items="quarantees"
                item-text="name"
                item-value="id"
                label="Вид гарантии *"
                name="quarantees"
                readonly
                required
                :rules="rules.requred"
              />
            </v-col>
            <v-col lg="1" md="3" sm="6">
              <v-text-field
                class="custom-font"
                v-model="calc.date"
                label="Гарантия c дд.мм.гггг *"
                persistent-hint
                v-mask="rules.dateMask"
                name="date"
                readonly
                required
                :rules="rules.requred"
              />
            </v-col>
            <v-col lg="1" md="3" sm="6">
              <v-text-field
                class="custom-font"
                v-model="calc.date2"
                label="Гарантия по дд.мм.гггг *"
                persistent-hint
                v-mask="rules.dateMask"
                name="date2"
                readonly
                required
                :rules="rules.requred"
              />
            </v-col>
            <v-col lg="2" md="2" sm="6">
              <v-text-field
                v-model="calc.days"
                id="getDays"
                label="Гарантия дней *"
                required
                name="days"
                type="number"
                readonly
                :rules="rules.requred"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="comments"
                name="comments"
                label="Ваше сообщение или пожелание (максимум 200 символов)"
              />
            </v-col>
            <v-col cols="3">
              <v-file-input
                label="Добавить документы"
                multiple
                show-size
                counter
                name="files"
                v-model="files"
              />
            </v-col>
            <v-col
              cols="3"
              style="display: flex; justify-content: end; align-items: end"
            >
              <v-btn color="success" type="submit" :disabled="process" :loading="process">Все верно, Отправить</v-btn
              >
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import Globalrules from "@/components/api/rules.js";
import { vidnologObl } from "@/plugins/vidnologObl";
import Swal from "sweetalert2";
import { sendRequestProtocols } from "../../axios";

export default {
  name: "SendRequest",
  components: {},
  data: () => ({
    rules: Globalrules,
    vidnologObl,
    no_purchase_number: false,
    nologObl: "",
    comments: "",
    email: "",
    name: "",
    phone: "",
    files: null,
    valid: false,
    process: false,
  }),
  computed: {
    inn() {
      return this.$store.getters.getMyOrganisation.inn;
    },
    orgName() {
      return this.$store.getters.getMyOrganisation.orgShortName;
    },
    calc: {
      get() {
        return this.$store.getters.calc;
      },
    },
    purchase_number: {
      get() {
        return this.calc.purchase_number;
      },
      set(value) {
        this.$store.dispatch("SET_CALC_PARAM", {
          param: "purchase_number",
          value,
        });
      },
    },
    summ() {
      return this.calc.summ;
    },
    quarantees() {
      return this.$store.getters.getQuarantees;
    },
    tagsList: {
      get() {
        return this.$store.getters.getBanksTags;
      },
    },
    bankTag: {
      get() {
        return this.$store.getters.getSelectedBankTags;
      },
    },
  },
  methods: {
    init() {
      if (
        !this.$store.getters.get_selected1.length &&
        !this.$store.getters.get_selected2.length
      ) {
        this.$router.push("/calcagent");
      }

      this.getProfile();
    },
    getProfile() {
      this.email = JSON.parse(localStorage.getItem("profile")).emailContact;
      const reg = /.+@.+\..+/g;
      const name = JSON.parse(localStorage.getItem("profile")).name;
      this.name = reg.test(name) ? "" : name;
      this.phone = JSON.parse(localStorage.getItem("profile")).phone;
    },
    async send() {
      if (!this.valid) {
        Swal.fire({
          icon: "warning",
          title: "Ошибка заполнения полей",
          text: "Все поля с '*' обязательны",
        });
        return;
      }

      this.process = true;

      const form = {
        inn: this.inn,
        orgName: this.orgName,
        nologObl: this.nologObl,
        email: this.email,
        name: this.name,
        phone: this.phone,
        purchase_number: this.purchase_number ? this.purchase_number : 'Нет номера закупки',
        summ: parseFloat(this.summ),
        quaranteesVal: this.quarantees.filter(
          (item) => item.id === this.calc.quaranteesVal
        )[0].name,
        date: this.calc.date,
        date2: this.calc.date2,
        days: this.calc.days,
        comments: this.comments,
        files: this.files,
        selected1: this.$store.getters.get_selected1,
        selected2: this.$store.getters.get_selected2,
        calcRegisterId: this.$store.getters.getCalcRegisterId,
        bankTag: this.tagsList.filter((item) => item.id === this.bankTag)[0]
          .name,
      };

      if (this.files !== null && this.files) {
        var ins = this.files.length;
        const FD = new FormData();
        for (var x = 0; x < ins; x++) {
          FD.append("files", this.files[x]);
        }
        FD.append("inn", this.inn);

        await this.$store.dispatch('fileToStorage',FD)

      }
      try {
        const data = await sendRequestProtocols("/sendRequest", "POST", form);
        //
        if (data.data.accepted && data.data.accepted.length) {
          Swal.fire({
            icon: "info",
            title: "Успешно!",
            text: `Заявка сформирована! Ожидайте пока наш менеджер вам перезвонит!`,
          });
        }
        if (!data.data.accepted.length) {
          Swal.fire({
            icon: "error",
            title: "Ошибка!",
            text: "Попробуйте позднее! Или сообщите в тех поддержку!",
          });
        }
      } finally {
        this.process = false;
        await this.$store.dispatch("setNewCalculation");
        await this.$store.dispatch("clearResults");
        await this.$store.dispatch("CLEAR_PROTOCOL_INFO");
        this.$store.commit("setProtocolInfoShowed", false);
        this.nologObl = "";
        this.comments = "";
        this.email = "";
        this.name = "";
        this.phone = "";
        this.files = null;
        this.valid = false;

        this.$router.push("/calcagent");
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style lang="sass" scoped>
</style>
